// THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
// Run: sh packages/api-types/scripts/run_generate_api_types.sh

import type { RuntimeSchema } from './runtime'
import { validateRuntimeValue } from './runtime'

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'OPTIONS'
export type EndpointSpec<TRequest, TResponse> = {
  path: string
  method: HttpMethod
  responseSchema: RuntimeSchema
  __types?: {
    request: TRequest
    response: TResponse
  }
}
export const defineEndpoint = <TRequest, TResponse>(spec: EndpointSpec<TRequest, TResponse>) => spec
export const validateEndpointResponse = <TRequest, TResponse>(endpoint: EndpointSpec<TRequest, TResponse>, value: unknown): TResponse =>
  validateRuntimeValue<TResponse>(endpoint.responseSchema, value, `${endpoint.method} ${endpoint.path} response`)
